import React from 'react';
import './homepageStyle.css';
import Navbar from './../../components/navbar/navbar'
import Footer from './../../components/footer/footer'
import AboutUs from './subComponents/aboutUs/aboutUs';
import Products from './subComponents/products/products';
import Applications from './subComponents/applications/applications';
import Contact from './subComponents/contact/contact';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import HeroSection from './subComponents/heroSection/heroSection';


export default function Homepage() {

    const siteContent = useSetSiteLanguage();
    
    return (
        <>
            <Navbar data={siteContent?.navbar}/>
            <div className='homepage__container'>

                <HeroSection />
            

                <Products 
                    text={siteContent?.productsPage?.summary?.text}
                    title={siteContent?.productsPage?.summary?.title} 
                    imgSrc={siteContent?.productsPage?.summary?.photo}/>
                <Applications 
                    title={siteContent?.applicationsPage?.summary?.title}
                    applications={siteContent?.applicationsPage?.applications}
                />
                <AboutUs 
                    text={siteContent?.aboutUsPage?.summary?.text}
                    title={siteContent?.aboutUsPage?.summary?.title} 
                    imgSrc={siteContent?.aboutUsPage?.summary?.photo}/>
                <Contact
                    title={siteContent?.contactSection?.title}
                    text={siteContent?.contactSection?.text}
                    email={siteContent?.contactSection?.email}
                    linkedin={siteContent?.contactSection?.linkedin}
                    whatsapp={siteContent?.contactSection?.whatsapp}/>
                
            </div>
            <Footer 
                email={siteContent?.contactSection?.email}
                linkedin={siteContent?.contactSection?.linkedin}
                whatsapp={siteContent?.contactSection?.whatsapp}/>
        </>
    );
}
